<template>
	<div class="single-project" v-if="currentPage">
		<section class="project-header bg-light">
			<div class="main-content">
				<div class="title-line">
					<h1 v-html="currentPage.title.rendered"></h1>
					<wpLink 
                    :url="archive" 
					:type="true"
                    v-html="'Se alle prosjekter'" />
				</div>
				<template v-if="currentPage.acf.facts && currentPage.acf.facts.intro">
					<div class="project-info">
						<p class="intro" v-html="currentPage.acf.facts.intro"></p>
						<div class="project-facts">
							<div class="facts-item">
								<p class="label" v-html="'Tidspunkt'"></p>
								<p v-html="currentPage.acf.facts.year"></p>
							</div>
							<div class="facts-item">
								<p class="label" v-html="'Sted'"></p>
								<p v-html="currentPage.acf.facts.place"></p>
							</div>
							<div class="facts-item">
								<Categories
										v-if="currentPage.acf && currentPage.acf._category" 
										:categories="currentPage.acf._category" :taxonomy="'projects_cat'" :link="false"/>
							</div>
						</div>
					</div>
				</template>
			</div>
		</section>
		<section class="main-content project-main">
			
			<div class="project-content">

				<section v-if="currentPage.acf.info.description">
					<DynamicHtml :html="currentPage.acf.info.description" />
				</section>
				<section class="project-gallery" v-if="currentPage.acf.info.gallery">
					<gallery :data="currentPage.acf.info.gallery"></gallery>
				</section>
				
			</div>

			<div class="sidebar bg-light" v-if="currentPage.acf && currentPage.acf.employee">

				<h3 v-html="currentPage.acf.contact_title"></h3>
				<employeeBlock v-for="(empId, i) in currentPage.acf.employee" :key="i" :id="empId" :type="'employees'"/>

			</div>

		</section>
	</div>
	<div v-else class="nothing single-page"></div>
</template>

<script>
import {mapGetters} from 'vuex'

import wpLink from '@/components/navigation/WpLink'
import gallery from '@/components/blocks/Gallery'
import employeeBlock from '@/components/blocks/EmployeeBlock'
import Categories from '@/components/blocks/CategoriesBlock'

export default {
	name: 'single-project',
	data(){
		return {
			type: null,
			archive: this.$route.meta.archive,
		}
	},
	components:{
		gallery,
		employeeBlock,
		Categories,
		wpLink
	},
	mounted() {
		
	},
	computed:{
	},
}
</script>

<style>
</style>

